import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { API } from "../lib/api";
import { useCart } from "../context/CartContext";

// getCustomer() returns the validated shipping form or null (it shows the errors itself).
export const PayPalCheckout = ({ getCustomer }) => {
  const { items, clear } = useCart();
  const [cfg, setCfg] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!API) return undefined;
    axios.get(`${API}/paypal/config`).then((r) => setCfg(r.data?.enabled ? r.data : null)).catch(() => setCfg(null));
    return undefined;
  }, []);

  if (!cfg?.client_id || !items.length) return null;
  return (
    <div data-testid="paypal-checkout" className="rounded-full overflow-hidden">
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture", locale: "es_ES" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "pill", height: 48, tagline: false, label: "paypal" }}
          fundingSource="paypal"
          forceReRender={[items.map((i) => `${i.id}:${i.qty}`).join(",")]}
          onClick={(_, actions) => (getCustomer() ? actions.resolve() : actions.reject())}
          createOrder={async () => {
            const customer = getCustomer();
            const r = await axios.post(`${API}/paypal/orders`, { items: items.map((i) => ({ product_id: i.id, quantity: i.qty })), customer }, { withCredentials: true });
            return r.data.id;
          }}
          onApprove={async ({ orderID }) => {
            try {
              await axios.post(`${API}/paypal/orders/${orderID}/capture`);
              clear();
              nav(`/payment/success?session_id=${orderID}`);
            } catch {
              toast.error("El pago con PayPal no se completó. No se ha realizado ningún cargo.");
            }
          }}
          onError={() => toast.error("PayPal no está disponible ahora mismo. Prueba con tarjeta.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
